import React, { FC } from 'react';
import { IconProps } from '../types';
import { iconDefaultProps } from '../const';
import IconStyled from '../icon.styled';

const IconReply: FC<IconProps> = ({ $size, ...rest }) => (
  <IconStyled {...{ $size, ...rest }}>
    <svg width={$size} height={$size} viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M5.99919 9.37665V11.9771C5.99915 11.9824 5.9983 11.9868 5.99712 11.9902L0.507634 6.5224C0.507621 6.52239 0.507609 6.52238 0.507596 6.52237C0.504988 6.51975 0.500294 6.51303 0.500012 6.50018C0.499728 6.48726 0.504186 6.47975 0.507271 6.47638L0.138455 6.13878L0.507272 6.47638L0.507516 6.47612L0.507636 6.476L5.99703 1.00826C5.99824 1.01179 5.99914 1.01617 5.9992 1.02133V3.64099V4.11757L6.47523 4.14042C8.66318 4.24543 10.2284 5.08088 11.218 6.58575L11.218 6.58578C12.0508 7.85192 12.5 9.65032 12.5 11.9782C12.5 11.9827 12.4994 11.9866 12.4986 11.9897C11.7754 11.0246 11.0609 10.2194 10.0519 9.67443L10.0514 9.67413C9.11334 9.169 7.96623 8.92267 6.51495 8.8769L5.99919 8.86063V9.37665Z"
        fill="#0C93DF"
        stroke="#0C93DF"
      />
    </svg>
  </IconStyled>
);

IconReply.defaultProps = iconDefaultProps;
IconReply.displayName = 'IconReply';

export default IconReply;
